/**
 * FAQs — Tab switching (desktop sidebar / mobile drill-down) + Accordion
 */
(function () {
  'use strict';

  document.querySelectorAll('.le-faqs').forEach(function (section) {
    var tabs = section.querySelectorAll('.le-faqs__tab');
    var panels = section.querySelectorAll('.le-faqs__panel');
    var backBtn = section.querySelector('.le-faqs__back');

    // Ensure panel-open is NOT set on page load
    section.classList.remove('le-faqs--panel-open');

    function switchPanel(target) {
      tabs.forEach(function (t) { t.classList.remove('le-faqs__tab--active'); });
      panels.forEach(function (p) { p.classList.remove('le-faqs__panel--active'); });

      var activeTab = section.querySelector('[data-category="' + target + '"]');
      if (activeTab) activeTab.classList.add('le-faqs__tab--active');

      var panel = section.querySelector('[data-panel="' + target + '"]');
      if (panel) panel.classList.add('le-faqs__panel--active');
    }

    // Tab click — switch panel + open drill-down on mobile
    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        switchPanel(tab.getAttribute('data-category'));
        section.classList.add('le-faqs--panel-open');
      });
    });

    // Back button (mobile)
    if (backBtn) {
      backBtn.addEventListener('click', function () {
        section.classList.remove('le-faqs--panel-open');
      });
    }

    // Accordion
    section.querySelectorAll('.le-faqs__question-btn').forEach(function (btn) {
      btn.addEventListener('click', function () {
        btn.closest('.le-faqs__question').classList.toggle('le-faqs__question--open');
      });
    });
  });
})();
